import { Container, Grid, Typography, Card } from "@mui/material";
import PersonalInjuryIcon from "@mui/icons-material/LocalHospital";
import CivilSuitIcon from "@mui/icons-material/Gavel";
import IntellectualPropertyIcon from "@mui/icons-material/Psychology";
import MediationIcon from "@mui/icons-material/Work";
import lightTheme from "../theme";
import React from "react";

export default function ServiceList() {
  return (
    <Container>
      <Container sx={{ margin: "20px 0px" }}>
        <Typography  variant="h2" sx={{ margin: "20px 0px" }}>
          My Services
        </Typography>
        <Typography variant="body">
          The first step is for me to work with you and come up with a plan to
          get the results you need. Through my understanding of the law and your
          understanding of the circumstances, you and I will craft a path to
          success. I know that legal action can sometimes be overwhelming. I am
          dedicated to providing you help in language that you can understand.
          If you don't feel like you understand your options, just ask, and I
          will work to find an explanation that works for you.
        </Typography>
      </Container>
      <Grid container justifyContent="center" rowSpacing={4} columnSpacing={4}>
        <Grid item xs={12} sm={6} md={4}>
          <Card sx={{ padding: "20px", backgroundColor:lightTheme.palette.cardBg.main }}>
            <Container
              disableGutters
              sx={{ display: "flex", alignItems: "center", margin: "10px" }}
            >
              <PersonalInjuryIcon
                color="primary"
                sx={{ paddingRight: "30px", fontSize: "4rem" }}
              />
              <Typography color="primary" variant="h4">
                Personal Injury
              </Typography>
            </Container>
            <Typography variant="body">
              Texas Attorney, Edward Russell, is also licensed to practice in
              Federal Court (Western District of Texas) and is experienced in
              auto accidents involving both personal and commercial insurance. I
              can help you settle or go to court if you are involved in
              Pedestrian, Auto, and Company vehicle accidents occurring in
              Texas. I have also helped clients pursue settlements involving
              Premises liability, and Workplace injuries.
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={7}>
          <Card  sx={{ padding: "20px", height: "88.8%", backgroundColor:lightTheme.palette.cardBg.main }}>
            <Container
              disableGutters
              sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IntellectualPropertyIcon
                color="primary"
                sx={{ paddingRight: "30px", fontSize: "4rem" }}
              />
              <Typography color="primary" variant="h4">
                Intellectual Property
              </Typography>
            </Container>
            <Typography variant="body">
              Patent litigation is the reason Edward Russell became an attorney.
              In Hawaii, circa 2012, Ed met Henk Rogers, Founder of Blue Planet
              Foundation. Henk's story inspired within Ed a deep fascination of
              Intellectual Property rights. Ed has also succesfully dealt with
              the USPTO regarding Trademark disputes. Many firms charge an
              upfront fee and then continue to charge for each correspondence
              with the USPTO before you ever receive your mark. Based on the
              complexity of your mark, I know how often you will need my
              services and will bid accordingly.
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={6}>
          <Card sx={{ padding: "20px", backgroundColor:lightTheme.palette.cardBg.main }}>
            <Container
              disableGutters
              sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <MediationIcon
                color="primary"
                sx={{ paddingRight: "30px", fontSize: "4rem" }}
              />
              <Typography color="primary" variant="h4">
                Mediation
              </Typography>
            </Container>
            <Typography variant="body">
              Edward Russell is certified in civil suit and family law
              mediation. He received these certifications from the prestigious
              mediation team at St. Mary's Law, in San Antonio Texas. If you
              have any pending trademark or patent litigation, give me a call to
              set up a Zoom teleconference, or in person mediation.
            </Typography>
          </Card>
        </Grid>
        <Grid item xs={12} sm={6} md={5}>
          <Card sx={{ padding: "20px", height: "82.5%", backgroundColor:lightTheme.palette.cardBg.main }}>
            <Container
              disableGutters
              sx={{
                padding: "10px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CivilSuitIcon
                color="primary"
                sx={{ paddingRight: "30px", fontSize: "4rem" }}
              />
              <Typography color="primary" variant="h4">
                Civil Settlements
              </Typography>
            </Container>
            <Typography variant="body">
              At Edward Russell Law, I prioritize the client's interests.
              Obtaining the best client outcome may mean going to trial, but it
              more often involves the ability to evaluate the value of a case
              and obtain a civil settlement, without the additional costs of
              trial.
            </Typography>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
}
